<template>
  <v-container fluid grid-list-xs py-0>
    <v-layout row wrap>

      <v-tooltip top>
        <v-switch id="alert-active" aria-label="alert-active" role="switch" slot="activator" hide-details v-model="isActive"></v-switch>
        <span>{{activeTooltip}}</span>
      </v-tooltip>
      <v-spacer/>

      <v-tooltip top>
        <v-btn id="alert-positive" v-if="displayFlag" aria-label="alert-positive" slot="activator" icon @click="positiveToggleClick">
          <v-icon v-if="positive" color="green">thumb_up</v-icon>
          <v-icon v-else>thumb_up</v-icon>
        </v-btn>
        <span>{{$t('admin.alerts.new.positive_tooltip')}}</span>
      </v-tooltip>

      <v-tooltip top>
        <v-btn id="alert-filter" v-if="displayFlag" aria-label="alert-filter" slot="activator" icon @click="alertFilterClick">
          <v-icon>filter_list</v-icon>
        </v-btn>
        <span>{{$t('admin.alerts.new.alert_filters')}}</span>
      </v-tooltip>

      <v-btn id="submit-alert-btn" v-if="!displayFlag" aria-label="submit-new-alert" color="primary" class="primary-text" @click="submitNewAlert">
        {{$t('admin.alerts.new.submit')}}
      </v-btn>
    </v-layout>
  </v-container>
</template>
<script>
  import {
    CREATE_INITIAL_ALERT,
    UPDATE_ALERT_ACTIVE_CRITERIA,
    EDIT_ALERT_DETAILS,
    GET_SAVED_FILTERS_FOR_ALERT
  } from '../../../store/action-types'
  import {
    SET_ALERT_DETAILS_ACTIVE_TOGGLE,
    SELECT_ALERT_POSITIVE,
    SET_ALERT_ACTIVE_TOGGLE
  } from '../../../store/mutation-types'
  import { mapState } from 'vuex'

  export default {
    name: 'alert-toggles',
    data () {
      return {}
    },
    computed: {
      ...mapState({
        alertsList: state => state.admin.newAlerts,
        alert: state => state.admin.newSingleAlert,
        displayFlag: state => state.admin.alertDetailsDisplayFlag
      }),
      activeTooltip () {
        return this.isActive ? this.$t('admin.alerts.new.deactivate_alert') : this.$t('admin.alerts.new.activate_alert')
      },
      isActive: {
        get () {
          return this.alert.active
        },
        set (value) {
          this.$store.commit(SET_ALERT_DETAILS_ACTIVE_TOGGLE, value)
          if (this.displayFlag) {
            this.$store.commit(SET_ALERT_ACTIVE_TOGGLE, {alertId: this.alert.id, active: value})
            this.$store.dispatch(UPDATE_ALERT_ACTIVE_CRITERIA, {alertId: this.alert.id, active: value})
          }
        }
      },
      positive: {
        get () {
          return this.$store.state.admin.newSingleAlert.positive
        },
        set (val) {
          this.$store.commit(SELECT_ALERT_POSITIVE, val)
          this.$store.dispatch(EDIT_ALERT_DETAILS, {alertId: this.$store.state.admin.newSingleAlert.id, alert: this.$store.state.admin.newSingleAlert})
        }
      }
    },
    methods: {
      submitNewAlert () {
        this.$store.dispatch(CREATE_INITIAL_ALERT, this.alert)
      },
      positiveToggleClick () {
        this.positive = !this.positive
      },
      alertFilterClick () {
        this.$store.dispatch(GET_SAVED_FILTERS_FOR_ALERT)
      }
      /* nameValidation (value) {
        if (value !== null) {
          return this.alertsList.map(el => el.description.toLowerCase()).includes(value.toLowerCase())
        } else {
          return true
        }
      } */
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/settings/alert/AlertToggles.vue